import { useEffect, useState, useCallback, useRef } from 'react';
import { authClient } from '../lib/auth-client';
import { AuthUser } from '../modules/(identity)/types/auth';
import axiosInstance from '../api/axiosConfig';

export const useAuth = () => {
    const { data: session, isPending: sessionPending } = authClient.useSession();
    const [userProfile, setUserProfile] = useState<AuthUser | null>(null);
    const [profileLoading, setProfileLoading] = useState(true);
    const fetchedForRef = useRef<string | null>(null);

    const fetchProfile = useCallback(async () => {
        try {
            const response = await axiosInstance.get('/api/me');
            setUserProfile(response.data);
        } catch {
            setUserProfile(null);
        } finally {
            setProfileLoading(false);
        }
    }, []);

    useEffect(() => {
        if (sessionPending) return;

        if (session?.user) {
            // Only re-fetch if user changed
            if (fetchedForRef.current !== session.user.id) {
                fetchedForRef.current = session.user.id;
                setProfileLoading(true);
                fetchProfile();
            }
        } else {
            fetchedForRef.current = null;
            setUserProfile(null);
            setProfileLoading(false);
        }
    }, [session, sessionPending, fetchProfile]);

    return {
        session,
        userProfile,
        isPending: sessionPending || profileLoading,
        isAuthenticated: !!session?.user,
    };
};
